import styled from "styled-components";

export const PostCardContainer = styled.div`
  display: flex;
  width: 328px;
  height: 235px;
  padding: 24px;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  border-radius: 24px;
  background: ${({ theme }) => theme.colors.default[50]};
`;

export const PostCardHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  align-self: stretch;
  color: ${({ theme }) => theme.colors.default[900]};
  text-overflow: ellipsis;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 125%; /* 30px */
`;

export const PostCardPill = styled.div<{
  $color: "default" | "primary" | "secondary";
}>`
  display: flex;
  padding: 4px 12px;
  align-items: flex-start;
  gap: 4px;
  border-radius: 12px;
  background: ${({ $color, theme }) => theme.colors[$color][200]};
  color: ${({ $color, theme }) => theme.colors[$color][900]};
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-transform: uppercase;
`;

export const PostCardFooter = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 10px;
  align-self: stretch;
`;
